import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../Styles/SportsSlider.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { FaAngleRight } from "react-icons/fa";
import Header from "./Components/Header";
import "../Styles/TeamOrder.css";
import Footer from "./Components/Footer";
import { enquery_Api } from "../Services/Operations/ProductAPI";
import { toast } from "react-toastify";

const Loader = () => {
  return (
    <div className="skeleton-loader-container">
      {[...Array(6)].map((_, index) => (
        <div key={index} className="skeleton-item">
          <div className="skeleton-image"></div>
          <div className="skeleton-text"></div>
          <div className="skeleton-button"></div>
        </div>
      ))}
      <style jsx>{`
        .skeleton-loader-container {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 20px;
          padding: 20px;
        }
        .skeleton-item {
          background: #fff;
          border-radius: 8px;
          overflow: hidden;
        }
        .skeleton-image {
          height: 200px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
        }
        .skeleton-text {
          height: 20px;
          margin: 10px;
          background: #f0f0f0;
          border-radius: 4px;
          animation: shimmer 1.5s infinite;
        }
        .skeleton-button {
          height: 40px;
          margin: 10px;
          background: #f0f0f0;
          border-radius: 4px;
          animation: shimmer 1.5s infinite;
        }
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style>
    </div>
  );
};

export const FamilyOrder = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const sports = [
    {
      name: "RUNNING",
      image1: "/asset/img/Ecom/RUNNING.jpeg",
      image2: "/asset/img/Ecom/4 (2).webp",
    },
    {
      name: "FITNESS",
      image1: "/asset/img/Ecom/FITNESS.jpeg",
      image2: "/asset/img/Ecom/3 (2).webp",
    },
    {
      name: "FOOTBALL",
      image1: "/asset/img/Ecom/FOOTBALL.jpeg",
      image2: "/asset/img/Ecom/20.webp",
    },
    {
      name: "BADMINTON",
      image1: "/asset/img/Ecom/BADMINTON.jpeg",
      image2: "/asset/img/Ecom/14 (3).webp",
    },
    {
      name: "CYCLING",
      image1: "/asset/img/Ecom/CYCLING.jpeg",
      image2: "/asset/img/Ecom/30.webp",
    },
    {
      name: "CRICKET",
      image1: "/asset/img/Ecom/CRICKET.jpeg",
      image2: "/asset/img/Ecom/34.webp",
    },
    {
      name: "BASKETBALL",
      image1: "/asset/img/Ecom/BASKETBALL.jpeg",
      image2: "/asset/img/Ecom/28.webp",
    },
  ];
  const products = [
    {
      id: "e0c644047c75dcf12413f34032db31cb8fc3896b49f6f76bcc164d58f82edd73f1612d0b635c25b0e8a154c919ae5d1e1b9cfe8cdc51864f0afc2b4ce0df64e6",
      title: "Swish women's basketball jersey",
      image: "/asset/img/Ecom/30.webp",
    },
    {
      id: "358555cbd45a189f283ce021bc712f34d8d78c500c9b9f8aff4fd21383a0a24133c13558dd79ef7a2a4c8236033222f523b635d4b619eb3489fc35c84deb7b03",
      title: "Men's basketball shooter shirt",
      image: "/asset/img/Ecom/33.webp",
    },
    {
      id: "123fc4b0b55d1e43da5b95491985f2bebd948dda3d2ba2eeb2667e9b35422a8853c28b7ee7503833a33f1b39b05068f83088ac2ad82fec116924550ab00c8403",
      title: "Viborg men's handball jersey l/s",
      image: "/asset/img/Ecom/13.webp",
    },
    {
      id: "3c83f338429dcd2f677ce95236925cfee5aba132751b1b6b6aa7c8db7cb8450e2efb066c103f4cdc7bec71b0b79ee9ee44bd6418b41c1451aa95976c33b57fd8",
      title: "Skjern women's handball jersey",
      image: "/asset/img/Ecom/29.webp",
    },
    {
      id: "f5de0a11181233d8fc946a97d8b8ea10b186293869aa4921a87f228ca57bb0809b26c8db5993981a8fb089e191f15304c733698b54e675f1e8fb546f0eb8326d",
      title: "Viborg men's handball jersey",
      image: "/asset/img/Ecom/19.webp",
    },
    {
      id: "6a65b0a01149ebaa07c3612e911022378a445b834934b29ac5f133678d1206f638a38c568ac14d3f47369d914f093e1e13b42c964d8206ef5cf2a5a8f4660c05",
      title: "Viborg men's handball jersey",
      image: "/asset/img/Ecom/28.webp",
    },
  ];
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
    sport_type: "",
    type: "Team",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("e : ", e);
    console.log("formData : ", formData);
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      if (
        !formData.name ||
        !formData.email ||
        !formData.mobile ||
        !formData.sport_type
      ) {
        alert("Please fill all required fields");
        return;
      }

      const response = await enquery_Api({
        ...formData,
        type: "Team",
      });

      console.log("API Response:", response);

      if (response?.success) {
        setFormData({
          name: "",
          email: "",
          mobile: "",
          message: "",
          sport_type: "",
          type: "Team",
        });
        toast.success(response.message);
      } else {
        alert(response?.message || "Submission failed");
      }
    } catch (error) {
      console.error("Submission error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div>
      
            <div style={{ width: "100%", marginTop: "56px" }}>
        <div
                        className="cms-image-container is-cover"
                        style={{ minHeight: "340px" }}
                       
                      >
                        <img
                          width="100%"
                         
                          src="Images/13.png"
                          className="cms-image f_lazy desctop-image-view desctop-mobile-type"
                          loading="lazy"
                          data-object-fit="cover"
                        />
                        </div>
        {/* <div
          className="block-container-2 configurator-product-slider"
          style={{ marginBottom: "0px",marginTop:"50px" }}
        >
          <Swiper
            modules={[Navigation]}
            spaceBetween={36}
            slidesPerView={4}
            navigation
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 28,
              },
              575: {
                slidesPerView: 2,
                spaceBetween: 28,
              },
              767: {
                slidesPerView: 3,
                spaceBetween: 28,
              },
              992: {
                slidesPerView: 4,
                spaceBetween: 36,
              },
              1220: {
                slidesPerView: 4,
                spaceBetween: 36,
              },
            }}
          >
            {products.map((product) => (
              <SwiperSlide key={product.id}>
                <div className="product--info bgweb2">
                  <a
                    className="product--image"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={product.image}
                      className="img-fluid f_lazy"
                      alt={product.title}
                      style={{ width: "100%", height: "auto" }}
                    />
                  </a>
                  <div className="product--details bghighlightColor">
                    <a
                      className="product--title t4 morelink"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {product.title}
                    </a>
                    <div className="product--detail-btn">
                      <a
                        className="btn button2 button-secondary"
                        target="_self"
                      >
                        Details
                        <FaAngleRight className="icon-arrow-right-bold" />
                      </a>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div> */}
         <div className="slider-container" style={{marginTop:"15px"}}>
                <h2 className="slider-heading middle1">
                 For Your Family Order
                </h2>
                <Slider {...settings}>
                  {sports.map((sport, index) => (
                    <div key={index} className="slide">
                      <div className="image-container">
                        <img
                          src={sport.image1}
                          alt={sport.name}
                          className="sport-image default-image"
                          loading="lazy"
                        />
                        <img
                          src={sport.image2}
                          alt={sport.name}
                          className="sport-image hover-image"
                          loading="lazy"
                        />
                      </div>
                      <h3 className="sport-name">{sport.name}</h3>
                    </div>
                  ))}
                </Slider>
              </div>
      </div>
      <div
        className="image-text-slider-element cms-element-shield-usp-blocks discountSlider exclusive-discount-slider"
        style={{ padding: "32px 32px 0px 32px" }}
      >
        <h2 style={{ textAlign: "center", fontWeight: "bold" }}>
          Why Order from Shield Sports?
        </h2>
        <Swiper
          style={{ padding: "18px" }}
          pagination={{ clickable: true }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              allowTouchMove: true,
              loop: true,
            },
            575: {
              slidesPerView: 1,
              allowTouchMove: true,
              loop: true,
            },
            767: {
              slidesPerView: 3,
              allowTouchMove: true,
              loop: true,
            },
            992: {
              slidesPerView: 4,
              allowTouchMove: false,
            },
            1220: {
              slidesPerView: 4,
              allowTouchMove: false,
            },
          }}
          loop={false}
        >
          <SwiperSlide>
            <div className="image-slider-item-container emotion-shield-usp-blocks-wrapper image-slider-container">
              <div className="image-container" style={{ height: "auto" }}>
                <img
                  src="/asset/icon6.svg"
                  className="img-fluid image-slider-image f_lazy desctop-image-view desctop-type"
                  width="50"
                  height="50"
                  alt="Attractive discounts"
                />
              </div>
              <div className="info-block">
                <div
                  className="title1 t1small middle1"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "90%",
                    fontWeight: "500",
                    marginBottom: "0px",
                    textAlign: "center",
                  }}
                >
                  Trusted by Thousands
                </div>
                <div className="description small1">
                  Rated 4.8/5 on Google, we provide end-to-end transparency,
                  from design to delivery.
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div
              className="image-slider-item-container emotion-shield-usp-blocks-wrapper image-slider-container"
              style={{ width: "100%" }}
            >
              <div className="image-container" style={{ height: "auto" }}>
                <img
                  src="/asset/icon5.svg"
                  className="img-fluid image-slider-image f_lazy desctop-image-view desctop-type"
                  width="50"
                  height="50"
                  alt="Satisfied customers"
                />
              </div>
              <div className="info-block">
                <div
                  className="title1 t1small middle1"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "90%",
                    fontWeight: "500",
                    marginBottom: "0px",
                    textAlign: "center",
                  }}
                >
                  Incredible Bulk Discounts
                </div>
                <div className="description small1">
                  We build long-term partnerships by offering exclusive team and
                  corporate pricing.
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="image-slider-item-container emotion-shield-usp-blocks-wrapper image-slider-container">
              <div className="image-container" style={{ height: "auto" }}>
                <img
                  src="/asset/icon6.svg"
                  className="img-fluid image-slider-image f_lazy desctop-image-view desctop-type"
                  width="50"
                  height="50"
                  alt="Personal design review"
                />
              </div>
              <div className="info-block">
                <div
                  className="title1 t1small middle1"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "95%",
                    fontWeight: "500",
                    marginBottom: "0px",
                    textAlign: "center",
                  }}
                >
                  Fast & Secure Payments
                </div>
                <div className="description small1">
                  Enjoy seamless and secure payment options for a smooth
                  transaction experience.
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="image-slider-item-container emotion-shield-usp-blocks-wrapper image-slider-container">
              <div className="image-container" style={{ height: "auto" }}>
                <img
                  src="/asset/icon5.svg"
                  className="img-fluid image-slider-image f_lazy desctop-image-view desctop-type"
                  width="50"
                  height="50"
                  alt="Personal design review"
                />
              </div>
              <div className="info-block">
                <div
                  className="title1 t1small middle1"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "90%",
                    fontWeight: "500",
                    marginBottom: "0px",
                    textAlign: "center",
                  }}
                >
                  Worldwide Shipping
                </div>
                <div className="description small1">
                  We offer global shipping for our customized jerseys.
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        <div className="swiper-pagination"></div>
      </div>
      <div className="form-container">
        <h2 className="form-title">Team Order Enquiry</h2>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form-row">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Name"
              className="form-input"
              required
            />
            <input
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleInputChange}
              placeholder="Phone Number"
              className="form-input"
              required
            />
          </div>
          <div className="form-row">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Mail ID"
              className="form-input"
              required
            />
            <input
              type="text"
              name="sport_type"
              value={formData.sport_type}
              onChange={handleInputChange}
              placeholder="Sports Type"
              className="form-input"
              required
            />
          </div>
          <div className="form-row">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              placeholder="Jersey requirement"
              className="form-textarea"
              rows="4"
            ></textarea>
          </div>

          <div className="form-row">
            <label className="form-checkbox">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
              />{" "}
              I am accepted terms and conditions
            </label>
          </div>

          <button
            type="submit"
            className={`form-button ${!isChecked ? "disabled" : ""}`}
            disabled={!isChecked}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>

      {/* <div className="slider-container">
        <h2 className="slider-heading middle1">
          SELECT YOUR SPORT, FIND YOUR GEAR, AND GET IN THE GAME!
        </h2>
        <Slider {...settings}>
          {sports.map((sport, index) => (
            <div key={index} className="slide">
              <div className="image-container">
                <img
                  src={sport.image1}
                  alt={sport.name}
                  className="sport-image default-image"
                />
                <img
                  src={sport.image2}
                  alt={sport.name}
                  className="sport-image hover-image"
                />
              </div>
              <h3 className="sport-name">{sport.name}</h3>
            </div>
          ))}
        </Slider>
      </div> */}
      <Footer />
    </div>
  );
};